import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import { authReducer } from './Auth/reducers';
import { tenantsReducer } from './Tenants/reducers';
import { apiDetailsReducer } from './ApiDetails/reducers';
import { usersReducer } from './Users/reducers';
import { rolesReducer } from './Roles/reducers';
import { queriesReducer } from './Studio/Queries/reducers';
import { queryCreationReducer } from './Studio/QueryCreation/reducers';
import { studioApiReducer } from './Studio/Api/reducers';
import { studioDatasetsReducer } from './Studio/Datasets/reducers';
import { copyQueryFiltersReducer } from './Studio/CopyQueryFilter/reducers';
import tower360ReduxSlice from '../Apps/Tower360/redux/tower360-redux-slice';
import tower360SimulationsSlice from '../Apps/Tower360/redux/simulations/simulations-redux-slice';
import tower360NumericPropsSlice from '../Apps/Tower360/redux/numericProps/numericProps-redux-slice';
import tower360CollectionsSlice from '../Apps/Tower360/redux/collections/collections-redux-slice';
import tower360ChartDataMapSlice from '../Apps/Tower360/redux/chartData/chartData-redux-slice';
import tower360ScenariosSlice from '../Apps/Tower360/redux/scenarios/scenarios-redux-slice';
import collectionsReduxSlice from '../components/Studio/QueryCreationTwo/ActionButtons/components/MoreMenu/Collections/redux/collections-redux-slice';
import goalTableColorsReduxSlice from '../components/Studio/QueryCreationTwo/ActionButtons/Visualization/ChartForms/GoalTable/redux/goalTable-redux-slice';
import listDataColumnsReduxSlice from '../components/Studio/QueryCreationTwo/ActionButtons/Visualization/ChartForms/List/redux/list-data-columns-redux-slice';
import errorModalReduxSlice from './ErrorModal/error-modal-redux-slice';
import subQuestionsModalSlice from '../Modules/Studio/Questions/EditQuestion/SubQuestions/AddSubQuestionModal/redux/subQuestionsModal.slice';
import subQuestionsSlice from 'Modules/Studio/Questions/EditQuestion/SubQuestions/redux/subQuestions.slice';
import propertiesListModalsSlice from 'Modules/Studio/Questions/EditQuestion/PropertiesList/redux/propertiesListModals.slice';
import relationsModalSlice from '@components/Studio/QueryCreationTwo/Props/modals/RelationsModal/redux/relations.slice';
import questionPreviewSlice from 'Modules/Studio/Questions/EditQuestion/QuestionPreview/redux/questionPreview.slice';
import mappingReduxSlice from 'Modules/Studio/Mappings/redux/mapping-redux-slice';
import IngestionSlice from 'Modules/Studio/components/StudioInfo/redux/Ingestion.slice';
import datasourcesReduxSlice from 'Modules/Studio/DataSources/redux/datasources-redux-slice';
import accessTagsDrawerSlice from 'Modules/Studio/Mappings/components/AccessTags/AccessTagsDrawer/redux/AccessTagsDrawer.slice';
import MappingFiltersReduxSlice from 'Modules/Studio/Mappings/redux/mappingFilters/mappingFilters.slice';
import editQuestionModalsSlice from 'Modules/Studio/Questions/EditQuestion/Layout/Toolbar/redux/editQuestionModalsSlice.slice';
import questionsListModalsSlice from 'Modules/Studio/QueriesList/components/QuestionsList/components/QuestionsListModals/redux/questionsListModals.slice';
import notificationReduxSlice from './Notification/notification-redux-slice';
import WindowFunctionsModalSlice from '@components/Studio/QueryCreationTwo/Props/modals/WindowFunctionsModal/redux/WindowFunctionsModal.slice';
import IngestionDataSourceListSlice from 'Modules/Studio/components/StudioInfo/Ingestion/IngestionStandaloneDropdown/IngestionByDataSource/redux/IngestionDataSourceList.slice';
import editDomainConceptModalsSlice from 'Modules/Studio/DomainEditor/components/EditDomainHeaderToolbar/ToolbarButtons/redux/EditDomainConceptModals.slice';
import apiListSlice from 'Modules/Studio/ApiListView/redux/apiList.slice';
import domainDependenciesErrorModalSlice from 'Modules/Studio/DomainEditor/ErrorModal/redux/domainDependenciesErrorModal.slice';
import domainDependenciesDeleteQueueSlice from 'Modules/Studio/DomainEditor/ErrorModal/redux/domainDependenciesDeleteQueue.slice';
import datasourceModalsReduxSlice from 'Modules/Studio/DataSources/components/Modals/redux/datasourceModals.slice';

export const reducers = combineReducers({
  tenants: tenantsReducer,
  userInfo: authReducer,
  users: usersReducer,
  router: routerReducer,
  roles: rolesReducer,
  queries: queriesReducer,
  queryCreation: queryCreationReducer,
  studioApi: studioApiReducer,
  queryCopiedFilters: copyQueryFiltersReducer,
  studioDatasets: studioDatasetsReducer,
  apiDetails: apiDetailsReducer,
  tower360: tower360ReduxSlice,
  tower360Simulations: tower360SimulationsSlice,
  tower360NumericProps: tower360NumericPropsSlice,
  tower360Collections: tower360CollectionsSlice,
  tower360ChartDataMap: tower360ChartDataMapSlice,
  tower360Scenarios: tower360ScenariosSlice,
  collections: collectionsReduxSlice,
  goalTableStyles: goalTableColorsReduxSlice,
  listDataColumns: listDataColumnsReduxSlice,
  errorModal: errorModalReduxSlice,
  notification: notificationReduxSlice,
  subQuestionsModal: subQuestionsModalSlice,
  subQuestions: subQuestionsSlice,
  propertiesListModals: propertiesListModalsSlice,
  relationsModal: relationsModalSlice,
  questionPreview: questionPreviewSlice,
  mapping: mappingReduxSlice,
  mappingFilters: MappingFiltersReduxSlice,
  ingestion: IngestionSlice,
  domainDependenciesErrorModal: domainDependenciesErrorModalSlice,
  domainDependenciesDeleteQueue: domainDependenciesDeleteQueueSlice,
  datasources: datasourcesReduxSlice,
  datasourceModals: datasourceModalsReduxSlice,
  accessTagsDrawer: accessTagsDrawerSlice,
  editQuestionModals: editQuestionModalsSlice,
  questionsListModals: questionsListModalsSlice,
  windowFunctionsModal: WindowFunctionsModalSlice,
  ingestionDataSourceList: IngestionDataSourceListSlice,
  editDomainConceptModals: editDomainConceptModalsSlice,
  apiList: apiListSlice,
});
